
function getEnv () {
  const url = window.location.host
  if (process.env.NODE_ENV === 'production') return 'pro'
  switch (url) {
    case '10.60.196.245':
      return 'test'
    case '10.60.196.244':
      return 'dev'
    default:
      return 'dev'
  }
}

export function isDev() {
  const testUrl = window && window.location.href.includes('admin-pre.renderbus.com')
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing' || testUrl
}

export default getEnv()
